import { MutationTree } from 'vuex';
import { NotificationData, NotificationPrefType, UserPreferences } from '@/features/settings/types';
import { UserInfo } from '@/features/users/types';
import {
  CountryInfo,
  RootState,
  AlertDialogType,
} from '../types';

const mutations: MutationTree<RootState> = {
  setNotification(state: RootState, value: boolean) {
    state.notification = value;
  },

  setNotificationData(state: RootState, value: Array<NotificationData>) {
    state.notificationData = value;
  },

  clearNotificationData(state: RootState) {
    state.notificationData = [];
    state.notification = false;
  },

  setCountries(state: RootState, value: Array<CountryInfo>) {
    state.countries = value;
  },

  setLoading(state: RootState, value: boolean) {
    state.loading = value;
  },

  setCheckoutLoading(state: RootState, value: boolean) {
    state.isCheckoutLoading = value;
  },

  // TODO: move to preferences module
  incrementIsUserPreferences(state: RootState) {
    state.isUserPreferences += 1;
  },

  // TODO: move to preferences module
  setUserPreferences(state: RootState, value: UserPreferences) {
    if (!value) {
      state.isUserPreferences = 0;
    } else {
      state.userPreferences = value;
      state.isUserPreferences += 1;
    }
  },

  // TODO: move to preferences module
  setNotificationPrefs(state: RootState, value: NotificationPrefType[]) {
    if (value) {
      state.notificationPrefs = value;
      state.isNotificationsPrefs = true;
    }
  },

  // TODO: move to preferences module
  patchUserPreferences(state: RootState, { key, value }: { key: string, value: never }) {
    const keys = key.split('/');
    switch (keys.length) {
      case 1:
        state.userPreferences[keys[0]] = value;
        break;
      case 2:
        state.userPreferences[keys[0]][keys[1]] = value;
        break;
      case 3:
        state.userPreferences[keys[0]][keys[1]][keys[2]] = value;
        break;
      default:
        break;
    }
  },

  // TODO: move to preferences module
  patchNotificationPref(state: RootState, { name, value }: { name: string, value: boolean }) {
    for (let i = 0; i < state.notificationPrefs.length; i += 1) {
      if (state.notificationPrefs[i].name === name) {
        state.notificationPrefs[i].show = value;
      }
    }
  },

  // TODO: move to preferences module
  setHistoryTableColumns(state: RootState, value: string[]): void {
    const { shipmentHistorySettings } = state.userPreferences;
    if (!shipmentHistorySettings) {
      state.userPreferences.shipmentHistorySettings = {
        columnOrder: [],
      };
    }

    if (state.userPreferences.shipmentHistorySettings) {
      state.userPreferences.shipmentHistorySettings.columnOrder = value;
    }
  },

  addAlertDialog(state: RootState, { bodyText, type }: AlertDialogType) {
    const dialog = {
      bodyText,
      type: type ?? 'info',
      id: Date.now().toString(),
    };

    state.alertDialogs.push(dialog);

    setTimeout(() => {
      const idx = state.alertDialogs.indexOf(dialog);
      state.alertDialogs.splice(idx, 1);
    }, 7000);
  },

  hideAlertDialog(state: RootState, id: string) {
    const idx = state.alertDialogs.findIndex((ad) => ad.id === id);

    state.alertDialogs.splice(idx, 1);
  },

  toggleConfirmDialog(state: RootState, {
    show, content, btnText, title,
  }) {
    state.confirmDialog = {
      show,
      content: content ?? state.confirmDialog?.content,
      btnText: btnText ?? state.confirmDialog?.btnText,
      title: title ?? state.confirmDialog?.title,
    };
  },

  // TODO: move to users module
  setUserInfo(state: RootState, value: UserInfo) {
    state.userInfo = value;
  },

  // TODO: move to users module
  setShowSuccessShip(state: RootState, value: boolean) {
    state.userInfo.isShowShipForSuccess = value;
  },

  incrementInitialDataLoaded(state: RootState) {
    state.isInitialDataLoaded += 1;
  },
};

export default mutations;
